<template>
  <FourElement @KeyModal="KeyModal" />

  <div style="margin-top: 20px;">
    <a-row>
      <a-col :span="5">
        <a-card :bordered="false" style="height: 1044px;">
          <Menu
            :ref="handleMenuRef"
            @categoty="categoty"
            @menuChange="menuChange"
            @initCategoryId="e => (postParams.categoryId = e[0])"
          />
        </a-card>
      </a-col>
      <a-col :span="19">
        <a-card :bordered="false" style="height: 1044px;">
          <a-radio-group
            v-model:value="postParams.languageCode"
            @change="initList"
            :key="item.languageCode"
            v-for="item in langList"
          >
            <a-radio-button :value="item.languageCode">
              {{ item.languageZhName }}
            </a-radio-button>
          </a-radio-group>
          <div style="color: red;font-size: 12px;" v-if="noValue">
            有 {{ noValue }} 条特定语言文案未维护，请尽快完善！
          </div>
          <Filter style="margin-top: 10px;" />
          <div class="staticLangContainer">
            <div></div>
            <div class="staticLangList">
              <List @valueForm="valueForm" />
              <div v-if="dataSource && dataSource.length > 0">
                <div class="fs14 lh30 fl" style="color: #999999;">
                  {{
                    `共 ${pagination.total} 条记录，第${
                      pagination.pageNum
                    }/${~~(pagination.total / pagination.pageSize) +
                      (pagination.total % pagination.pageSize
                        ? 1
                        : pagination.total === 0
                        ? 1
                        : 0)}页`
                  }}
                </div>
                <div style="display: flex; flex-direction: row; float: right;">
                  <a-pagination
                    v-if="pagination.pageSize"
                    class="mr20"
                    v-model:current="pagination.pageNum"
                    :total="pagination.total"
                    v-model:pageSize="pagination.pageSize"
                    :showTotal="() => false"
                    :showSizeChanger="false"
                    @change="initList"
                  />
                  <a-select
                    class="mr10"
                    style="min-width: 80px;"
                    v-model:value="pagination.pageSize"
                    @change="initList"
                    placeholder="条"
                    :options="[
                      { value: 10, label: 10 },
                      { value: 20, label: 20 },
                      { value: 30, label: 30 },
                      { value: 40, label: 40 },
                      { value: 50, label: 50 }
                    ]"
                  >
                  </a-select>
                  <div class="lh30 mr10">条/页</div>
                  <div class="lh30 mr10">跳转至</div>
                  <a-input-number
                    class="mr10"
                    style="width: 50px;"
                    :value="pagination.pageNum"
                    placeholder="页"
                    :max="
                      pagination.total <= pagination.pageSize
                        ? 1
                        : Math.ceil(pagination.total / pagination.pageSize)
                    "
                    :min="1"
                    @change="watchPage"
                  />
                  <div class="lh30">页</div>
                </div>
              </div>
            </div>
          </div>
        </a-card>
      </a-col>
    </a-row>
  </div>
  <Log />
  <MixModal />
  <ModuleForm :ref="handleSetRef"></ModuleForm>
  <KeyForm
    :ref="handleSetRefB"
    :categoryId="postParams.categoryId"
    @initList="initList"
  ></KeyForm>
  <ValueForm
    :ref="handleSetRefC"
    :languageCode="postParams.languageCode"
    :siteCode="postParams.siteCode"
    @initList="initList"
  ></ValueForm>
</template>
<script>
import { toRefs, reactive, provide, onMounted, h } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import FourElement from './components/FourElement'
import Filter from './components/Filter'
import List from './components/List'
import Log from './components/Log'
import MixModal from './components/MixModal'
import Menu from './components/Menu'
import useAPI from 'UseApi'
import ModuleForm from './components/ModuleForm'
import KeyForm from './components/KeyForm'
import ValueForm from './components/ValueForm'
import { no_configuration_count } from './../../server/modules/8997'
import {
  MailOutlined,
  AppstoreOutlined,
  SettingOutlined
  // MenuUnfoldOutlined
} from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
const {
  i18n_value_list_post_,
  col_deleteCol_post_,
  col_activeCol_post_,
  col_queryColLog_post_,
  mixCol_page_post_,
  mixCol_saveMixCol_post_,
  mixCol_remove_mixId_get_,
  mixCol_getMixColDetail_mixId_get_,
  mixCol_checkMixCol_post_,
  category_addOrUpdate_post_,
  category_delete_post_,
  category_list_post_,
  // i18n_key_list_post,
  site_all_
  // ,
  // common_lang_get_
  //  {
  //   brandId: 1,
  //   channelId: 1,
  //   siteId: 1,
  //   terminalId: 1
  //   }
} = useAPI(null, [3426, 4240, 5922, 8992, 8997])
import { search_value_post } from '@/server/modules/8997_lang.js'
export default {
  components: {
    Menu,
    FourElement,
    Filter,
    List,
    Log,
    MixModal,
    ModuleForm,
    KeyForm,
    ValueForm
  },
  setup() {
    const state = reactive({
      globalKey: '',
      noClicked: false,
      noVisible: false,
      allData: [],
      mode: 'vertical',
      menuSelectKeys: [],
      categoryName: '',
      categoryNameArr: [],
      // 开始 ===================
      clickPopoverFlag: false,
      leftMenuLoading: true,
      // 结束 ===================
      selectedKeys: ['7'],
      openKeys: ['7'],
      items: [
        {
          key: 'mail',
          icon: () => h(MailOutlined),
          label: 'Navigation One',
          title: 'Navigation One'
        },
        {
          key: 'app',
          icon: () => h(AppstoreOutlined),
          label: 'Navigation Two',
          title: 'Navigation Two'
        },
        {
          key: 'sub1',
          icon: () => h(SettingOutlined),
          label: 'Navigation Three - Submenu',
          title: 'Navigation Three - Submenu',
          children: [
            {
              type: 'group',
              label: 'Item 1',
              children: [
                {
                  label: 'Option 1',
                  key: 'setting:1'
                },
                {
                  label: 'Option 2',
                  key: 'setting:2'
                }
              ]
            },
            {
              type: 'group',
              label: 'Item 2',
              children: [
                {
                  label: 'Option 3',
                  key: 'setting:3'
                },
                {
                  label: 'Option 4',
                  key: 'setting:4'
                }
              ]
            }
          ]
        },
        {
          key: 'alipay',
          label: h(
            'a',
            { href: 'https://antdv.com', target: '_blank' },
            'Navigation Four - Link'
          ),
          title: 'Navigation Four - Link'
        }
      ],
      warningAlert: true,
      mixParams: {
        peerShowFlag: 0, // 分体是否一行展示，0-否，1-是
        mixId: null, // mixId，编辑时必传，新增不传
        colId: null // collectionId
      },
      mixPagination: {
        pageNum: 1, // 当前页
        pageSize: 10, // 每页的数量
        total: 0 // 总记录数
      },
      category: false,
      mixVisible: false,
      mixDetailVisible: false,
      mixVisibleChange: (mixVisible = false) => {
        if (mixVisible) {
          state.handleReset()
          state.mixDetailVisible = false
          state.getMixList()
        }
        state.mixVisible = mixVisible
      },
      mixShowDetail: ({ mixId }) => {
        state.mixDetailVisible = true
        state.getMixDetail({ mixId })
      },
      checkMixCol: async (colId, mixType = 1) => {
        let params = {
          peerShowFlag: state.mixParams.peerShowFlag,
          ...state.searchParams,
          colId,
          mixType,
          mainColId: state.mixParams.colId
        }
        if (state.mixParams.mixId !== null) {
          params.mixId = state.mixParams.mixId
        }
        const { success, retInfo } = await mixCol_checkMixCol_post_({
          ...params
        })

        if (success) {
          console.log('')
        } else {
          if (state.warningAlert) {
            if (retInfo === '' || retInfo === null) return
            state.warningAlert = false
            message.warning(retInfo)
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
        }
      },
      addMixData: () => {
        state.mixDetailVisible = true
        state.mixParams = {
          peerShowFlag: 0, // 分体是否一行展示，0-否，1-是
          mixId: null, // mixId，编辑时必传，新增不传
          colId: null // collectionId
        }
        state.mixDataSource = [
          {
            priority: null,
            colId: null,
            crossNum: null
          }
        ]
      },
      cancel() {},
      cancelEditMix: () => {
        state.mixDetailVisible = false
        state.mixParams = {
          peerShowFlag: 0, // 分体是否一行展示，0-否，1-是
          mixId: null, // mixId，编辑时必传，新增不传
          colId: null // collectionId
        }
        state.mixDataSource = [
          {
            priority: null,
            colId: null,
            crossNum: null
          }
        ]
      },
      mixColDetailList: [{ colId: null, crossNum: null, priority: null }],
      getMixDetail: async ({ mixId }) => {
        const {
          success,
          data,
          retInfo
        } = await mixCol_getMixColDetail_mixId_get_({
          mixId
        })
        if (success) {
          const { mixColDetailList, mixId, peerShowFlag, colId } = data
          state.mixParams = { ...state.mixParams, mixId, peerShowFlag, colId }
          if (mixColDetailList.length === 0) {
            state.mixDataSource = [
              {
                priority: null,
                colId: null,
                crossNum: null
              }
            ]
          } else {
            state.mixDataSource = [...mixColDetailList]
          }
        } else {
          if (state.warningAlert) {
            if (retInfo === '' || retInfo === null) return
            state.warningAlert = false
            message.warning(retInfo)
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
        }
      },
      relieveMix: async ({ id = null }) => {
        if (!id) {
          message.warning('未传入ID！')
          return
        }
        const { retInfo, success } = await mixCol_remove_mixId_get_({
          mixId: id
        })
        if (success) {
          message.success(retInfo)
          state.getMixList()
        } else {
          if (state.warningAlert) {
            if (retInfo === '' || retInfo === null) return
            state.warningAlert = false
            message.warning(retInfo)
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
        }
      },
      removeMixDataSource: index => {
        let mixDataSource = [...state.mixDataSource]
        mixDataSource.splice(index, 1)
        state.mixDataSource = [...mixDataSource]
      },
      saveMixCol: async (successTitle = '修改') => {
        let hasError = false
        if (state.mixParams.colId === '' || state.mixParams.colId === null) {
          if (state.warningAlert) {
            hasError = true
            state.warningAlert = false
            message.warning('混合商品Collection ID必填')
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
          return
        }
        let mixDataSource = [...state.mixDataSource]
        mixDataSource.map((v, index = 0) => {
          v.priority = index - 0 + 1
          if (v.colId === '' || v.colId === null) {
            if (state.warningAlert) {
              state.warningAlert = false
              message.warning('collection ID必填')
              setTimeout(() => {
                state.warningAlert = true
              }, 3000)
            }
            hasError = true
            return
          }
          if (
            v.crossNum === '' ||
            v.crossNum === null ||
            v.crossNum - 0 === 0
          ) {
            if (state.warningAlert) {
              state.warningAlert = false
              message.warning('穿插个数必填')
              setTimeout(() => {
                state.warningAlert = true
              }, 3000)
            }
            hasError = true
            return
          }
        })
        if (!state.mixParams.colId || state.mixParams.colId === '') {
          if (state.warningAlert) {
            state.warningAlert = false
            message.warning('未填写混合商品Collection ID！')
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
          hasError = true
          return
        }
        if (hasError) {
          return
        }
        const { success, retInfo } = await mixCol_saveMixCol_post_({
          ...state.mixParams,
          ...state.searchParams,
          mixColDetailList: [...mixDataSource]
        })
        if (success) {
          message.success(`${successTitle}成功!`)
          state.getMixList()
        } else {
          if (state.warningAlert) {
            if (retInfo === '' || retInfo === null) return
            state.warningAlert = false
            message.warning(retInfo)
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
        }
      },
      getMixList: async () => {
        const params = {
          ...state.formState
        }
        delete params.time
        const { success, data, retInfo } = await mixCol_page_post_({
          ...state.searchParams,
          ...params,
          ...state.mixPagination
        })
        if (success) {
          const { list, pageNum, pageSize, total } = data
          state.mixPagination = { pageNum, pageSize, total }
          state.mixDataList = list
          // if (list.length === 0) {
          //   state.mixDetailVisible = true
          // } else {
          //   state.mixDetailVisible = false
          // }
        } else {
          if (state.warningAlert) {
            if (retInfo === '' || retInfo === null) return
            state.warningAlert = false
            message.warning(retInfo)
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
        }
      },
      mixDataList: [],
      addMixDataSource: (index = 0) => {
        let mixDataSource = [...state.mixDataSource]
        mixDataSource.splice(index + 1, 0, {
          priority: null,
          colId: null,
          crossNum: null
        })
        state.mixDataSource = mixDataSource
      },
      mixDataSource: [
        {
          priority: null,
          colId: null,
          crossNum: null
        }
      ],
      checkLength: (key, len, text) => {
        switch (key) {
          case 'colId':
            if (
              state.mixParams.colId === null ||
              state.mixParams.colId === ''
            ) {
              message.warning('请填写混合商品Collection ID!')
            } else {
              state.mixParams.colId = state.mixParams.colId.substring(0, len)
            }
            break
          case 'colId_':
            if (text.colId === null || text.colId === '') {
              message.warning('请填写Collection ID!')
            } else {
              text.colId = text.colId.substring(0, len)
            }
            break
          case 'crossNum':
            if (
              text.crossNum === null ||
              text.crossNum === '' ||
              text.crossNum === 0
            ) {
              message.warning('穿插个数必填!')
            } else {
              text.crossNum = text.crossNum.substring(0, len)
            }
            break
        }
      },
      mixIndex: 0,
      mixCustomRow: (row, index) => {
        return {
          draggable: true,
          props: {
            draggable: true
          },
          sourceRowIndex: 0,
          onDragstart: e => {
            e.stopPropagation()
            state.mixIndex = index
          },
          onDragover: e => {
            e.preventDefault()
          },
          onDrop: e => {
            e.stopPropagation()
            const row = state.mixDataSource.splice(state.mixIndex, 1)
            state.mixDataSource.splice(index, 0, ...row)
          }
        }
      },
      clicked: false,
      hovered: false,
      handleHoverChange: visible => {
        state.clicked = false
        state.hovered = visible
      },
      handleClickChange: visible => {
        state.clicked = visible
        state.hovered = false
      },
      hide: () => {
        state.clicked = false
        state.hovered = false
      },
      watchPage: e => {
        state.pagination.pageNum = e
        state.initList()
      },
      inputLengthCut: ({ val = null, key = null, len = 0 }) => {
        if (!val) return
        let value = val.split('').splice(0, len)
        state.postParams[key] = value.join('')
        if (key === 'seoTitle') {
          console.log('val', val)
        }
        if (key === 'name') {
          // 如果是修改标题
          if (state.postParams.colSeo && state.postParams.colSeo.seoUrl) {
            state.inputLengthCut({
              val: state.postParams.colSeo.seoUrl,
              type: 'colSeo',
              key: 'seoUrl',
              len: 255,
              reg: true
            })
          }

          if (state.postParams.colSeo && state.postParams.colSeo.seoTitle) {
            state.inputLengthCut({
              val: state.postParams.colSeo.seoTitle,
              type: 'colSeo',
              key: 'seoTitle',
              len: 70
            })
          }
        }
      },
      logVisible: false, // 日志弹窗
      col_activeCol_post: params => {
        col_activeCol_post_(params, state.initList)
      },
      col_queryColLog_post: params => {
        if (params.colId) {
          state.colId = params.colId
        }

        col_queryColLog_post_({ ...params }, state)
      },
      deleteFun: params => {
        col_deleteCol_post_(params, state.initList, state)
        params.showDel = false
      },
      value: null,
      route: useRoute(),
      router: useRouter(),
      jumpPage: (path, query) => {
        console.log('query ', query)
        state.router.push({ path, query })
      },
      dataSource: [],
      searchParams: {
        terminalId: undefined,
        brandId: undefined,
        channelId: undefined,
        siteId: undefined
      },
      brands: [],
      channels: [],
      sites: [],
      terminals: [],
      postParams: {
        seoUrl: null,
        timeSet: [],
        siteCode: undefined,
        itemKey: null, // 标题
        colId: null, // 编码
        categoryId: undefined,
        languageCode: '',
        status: -1, // 状态
        shopifyColId: null, // shopfiy id
        createTimeBegin: null, // 开始时间
        createTimeEnd: null, // 结束时间
        colType: -1, // 类型
        creatorName: null, // 创建人
        remark: null, // 备注
        peopleGoodsFlag: -1,
        promotionFlag: -1,
        releationType: null
      },
      resetParams: () => {
        state.postParams = {
          categoryId: state.postParams.categoryId,
          seoUrl: null,
          timeSet: [],
          itemKey: null, // 标题
          defaultValue: null, // 编码
          status: -1, // 状态
          shopifyColId: null, // shopfiy id
          createTimeBegin: null, // 开始时间
          createTimeEnd: null, // 结束时间
          colType: -1, // 类型
          creatorName: null, // 创建人
          remark: null, // 备注
          peopleGoodsFlag: -1,
          promotionFlag: -1,
          releationType: null
        }
        state.initList()
      },
      addOrUpdateCategory: params => {
        category_addOrUpdate_post_(params).then(res => {
          console.log(res)
        })
      },
      deleteCategory: params => {
        category_delete_post_(params).then(res => {
          console.log(res)
        })
      },
      categoryList: [],
      getCategory: () => {
        state.leftMenuLoading = true
        category_list_post_().then(res => {
          if (res) {
            res.forEach(elem => {
              elem.showButton = false
              elem.showEdit = false
              elem.children.forEach(ele => {
                ele.showButton = false
              })
            })
          }
          state.leftMenuLoading = false
          state.categoryList = res
        })
      },
      changeFilterTime: timeSet => {
        state.postParams = {
          ...state.postParams,
          createTimeBegin:
            timeSet === null || timeSet.length === 0 ? null : timeSet[0],
          createTimeEnd:
            timeSet === null || timeSet.length === 0 ? null : timeSet[1]
        }
      },
      deletePeopleGoodsFlag: (params = {}) => {
        let newParams = { ...params }
        delete newParams.peopleGoodsFlag
        return newParams
      },
      pagination: {
        pageNum: 1, // 当前页
        pageSize: 10, // 每页的数量
        total: 0 // 总记录数
      },
      resetPagination: () => {
        state.pagination = {
          pageNum: 1, // 当前页
          pageSize: 10, // 每页的数量
          total: 0 // 总记录数
        }
        state.initList()
      },
      logList: [],
      logPagination: {
        pageNum: 1, // 当前页
        pageSize: 5, // 每页的数量
        total: 0 // 总记录数
      },
      noValue: null,
      formState: {},
      handleReset() {
        state.formState = {}
        state.handleQuery()
      },
      async handleQuery() {
        state.mixPagination.pageNum = 1
        state.getMixList()
      },
      changeRangePicker(date) {
        state.formState.updateTimeBegin = date[0]
        state.formState.updateTimeEnd = date[1]
      },
      initList: async () => {
        const data = await no_configuration_count({
          categoryId: state.postParams.categoryId,
          siteCode: state.searchParams.siteId,
          languageCode: state.postParams.languageCode
        })
        state.noValue = data.data
        state.noClicked = true
        console.log(state.noValue)
        state.loading = true
        if (state.route.query.terminalId) {
          state.searchParams.terminalId = state.route.query.terminalId - 0
        }
        if (state.route.query.brandId) {
          state.searchParams.brandId = state.route.query.brandId - 0
        }
        if (state.route.query.channelId) {
          state.searchParams.channelId = state.route.query.channelId - 0
        }
        if (state.route.query.siteId) {
          state.searchParams.siteId = state.route.query.siteId - 0
        }
        const obj = state.allData.find(item => {
          return (
            item.terminalId === state.searchParams.terminalId &&
            item.terminalId === state.searchParams.terminalId &&
            item.brandId === state.searchParams.brandId &&
            item.channelId === state.searchParams.channelId &&
            item.siteId === state.searchParams.siteId
          )
        })
        const { siteCode, defaultLanguage } = obj || {}
        state.searchParams.siteCode = siteCode
        state.searchParams.languageCode =
          state.postParams.languageCode || defaultLanguage?.languageCode

        state.postParams = {
          ...state.postParams,
          ...state.searchParams,
          ...state.pagination
        }

        const res = await i18n_value_list_post_(state.postParams)
        state.loading = false
        state.dataSource = res.list
        state.pagination.total = res.total
      }, // 初始化标题列表
      // 开始 ===================
      addcategory() {},
      // 鼠标悬浮在title时触发
      mouse2Title: item => {
        item.showButton = true
      },
      // 鼠标离开title时触发
      mouseLeaveTitle: item => {
        if (!state.clickPopoverFlag) {
          item.showButton = false
        }
      },
      // title点击 +
      addNewModule: item => {
        console.log(item)
      },
      // 点击popover
      clickTitlePopover: item => {
        console.log(item)
        state.clickPopoverFlag = true
      },
      mouseLeavePopover: item => {
        item.showButton = false
        state.clickPopoverFlag = false
      },
      // popover点击编辑
      titleMenuEdit(item) {
        category_addOrUpdate_post_(item).then(res => {
          console.log(res)
        })
      },
      // popover点击删除
      titleMenuDelete(item) {
        console.log(item)
        category_delete_post_({ ids: item.id, optUser: '' }).then(res => {
          console.log(res)
        })
      },
      shouldShowTooltip(text) {
        const maxWidth = 100
        const span = document.createElement('span')
        span.style.visibility = 'hidden'
        span.style.position = 'absolute'
        span.style.whiteSpace = 'nowrap'
        span.textContent = text
        document.body.appendChild(span)
        const textWidth = span.getBoundingClientRect().width
        document.body.removeChild(span)
        return textWidth > maxWidth
      },
      inputCategoryName(name) {
        console.log(name)
      },
      menuChange(key) {
        state.postParams.categoryId = key
        state.postParams.itemKey = ''
        state.globalKey = ''
        if (state.postParams.siteCode) state.initList()
      },
      async searchCategoryList() {
        state.leftMenuLoading = true
        await category_list_post_({
          name: state.categoryName
        }).then(res => {
          if (res) {
            res.forEach(elem => {
              elem.showButton = false
              elem.showEdit = false
              elem.children.forEach(ele => {
                ele.showButton = false
              })
            })
          }
          state.leftMenuLoading = false
          state.categoryList = res
          if (!state.categoryName || '' === state.categoryName) {
            this.categoryNameArr = res
          }
        })
      },
      pageRef: null,
      keyRef: null,
      valueRef: null,
      langList: [],
      siteArr: [],
      menuRef: null,
      handleMenuRef: n => {
        state.menuRef = n
      },
      handleSetRef: n => {
        state.pageRef = n
      },
      handleSetRefB: n => {
        state.keyRef = n
      },
      handleSetRefC: n => {
        state.valueRef = n
      },
      valueForm(item) {
        state.valueRef.open(item)
      },
      KeyModal(item) {
        state.keyRef.open(item)
      },
      categoty(item) {
        state.pageRef.open(item)
      },
      async getKeys() {
        // const res = await i18n_key_list_post()
        // if (res.success) state.langList = res.list
      },
      //分组
      groupBy: (list, fn) => {
        const groups = {}
        list.forEach(function(o) {
          const group = JSON.stringify(fn(o))
          groups[group] = groups[group] || []
          groups[group].push(o)
        })
        return Object.keys(groups).map(function(group) {
          return { group: groups[group] }
        })
        // return groups
      },
      async querySiteAll() {
        const res = await site_all_()
        state.allData = res || []
        const groupArr = state.groupBy(res, v => v.brandId)
        groupArr.forEach(item => {
          item.brandId = item.group[0].brandId
          item.brandName = item.group[0].brandName
          item.channels = state.groupBy(item.group, v => v.channelId)
          item.channels.forEach(itemB => {
            itemB.channelId = itemB.group[0].channelId
            itemB.channelName = itemB.group[0].channelName
            itemB.sites = state.groupBy(itemB.group, v => v.siteId)
            itemB.sites.forEach(itemC => {
              itemC.siteId = itemC.group[0].siteId
              itemC.siteName = itemC.group[0].siteName
              itemC.siteCode = itemC.group[0].siteCode
              itemC.terminals = state.groupBy(itemC.group, v => v.terminalId)
              itemC.terminals.forEach(itemD => {
                itemD.terminalId = itemD.group[0].terminalId
                itemD.terminalName = itemD.group[0].terminalName
              })
            })
          })
        })
        state.siteArr = groupArr
        state.searchParams.brandId = 1
      },
      resetSiteInfo(item) {
        state.langList = item.group[0]?.languages
        state.postParams.languageCode =
          item.group[0]?.defaultLanguage?.languageCode
        state.postParams.languageCode =
          item.group[0]?.defaultLanguage?.languageCode
        if (state.postParams.languageCode) state.initList()
      },
      // 结束 ===================
      handleGlobalSearch: async () => {
        const { success, data, retInfo } = await search_value_post({
          itemKey: state.globalKey,
          siteCode: state.searchParams.siteId,
          languageCode: state.postParams.languageCode
        })
        if (success && data) {
          if (
            data.category &&
            data.category.children &&
            data.category.children.length
          ) {
            state.menuRef.openKeys = [data.category.id]
            state.menuRef.selectedKeys = [data.category.children[0].id]
            state.postParams.categoryId = data.category.children[0].id
            state.postParams.itemKey = state.globalKey
            state.initList()
          }
        } else {
          state.menuRef.selectedKeys = []
          state.postParams.categoryId = []
          state.postParams.itemKey = ''
          state.dataSource = []
          message.error(retInfo)
        }
      }
    })
    onMounted(() => {
      console.log('state.route.query ', state.route.query)
      if (state.route.query.terminalId) {
        state.searchParams.terminalId = state.route.query.terminalId - 0
      }
      if (state.route.query.brandId) {
        state.searchParams.brandId = state.route.query.brandId - 0
      }
      if (state.route.query.channelId) {
        state.searchParams.channelId = state.route.query.channelId - 0
      }
      if (state.route.query.siteId) {
        state.searchParams.siteId = state.route.query.siteId - 0
        state.router.replace({ query: {} })
      }
      // common_querySiteInfo_get_({
      //   state
      // })
      state.querySiteAll()
      // state.initList()
      // state.searchCategoryList()
    })
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>
<style>
* {
  scrollbar-width: thin;
  scrollbar-color: #aaaaaa transparent;
}
</style>
<style scoped lang="scss">
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}

.staticLangContainer {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
}

.staticLangMenu {
  flex-grow: 0;
  width: 250px;
}
.loadingMenu {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 700px;
}
.interaction-plus {
  color: #000;
  text-decoration: none;
}
.interaction-plus:hover {
  color: #0574f6; /* 设置悬浮时的颜色 */
}
.interaction-edit {
  color: #000;
  text-decoration: none;
}
.interaction-edit:hover {
  color: #0574f6; /* 设置悬浮时的颜色 */
}
.leftMenu {
  height: 655px;
  overflow: scroll;
  overflow-x: hidden;
}
.ellipsis {
  position: relative;
  display: inline-block;
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.staticLangList {
  width: 100%;
  height: 600px;
}
</style>
